// libs/react-mosaic-component/src/lib/buttons/AddTabButton.tsx
import classNames from "classnames";
import { noop } from "lodash-es";
import React from "react";
import { MosaicWindowContext } from "../contextTypes.mjs";
import { OptionalBlueprint } from "../util/OptionalBlueprint.mjs";
import { DefaultToolbarButton } from "./MosaicButton.mjs";
var AddTabButton = class extends React.PureComponent {
  static contextType = MosaicWindowContext;
  render() {
    return /* @__PURE__ */ React.createElement(
      DefaultToolbarButton,
      {
        title: "Add Tab",
        className: classNames(
          "add-tab-button",
          OptionalBlueprint.getIconClass(
            this.context.blueprintNamespace,
            "ADD_COLUMN_RIGHT"
          )
        ),
        onClick: this.addTab
      }
    );
  }
  addTab = () => {
    this.context.mosaicWindowActions.addTab().then(() => {
      if (this.props.onClick) {
        this.props.onClick();
      }
    }).catch(noop);
  };
};
export {
  AddTabButton
};
